import { render, staticRenderFns } from "./AddAlert.vue?vue&type=template&id=43d46d12&"
import script from "./AddAlert.vue?vue&type=script&lang=js&"
export * from "./AddAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports